// extracted by mini-css-extract-plugin
module.exports = {"InputRow":"CustomerInformation_InputRow__3SMx_","Input":"CustomerInformation_Input__2_RCw"};